import React from 'react';
import PropTypes from 'prop-types';

const SectionTitle = ({ children }) => (
  <div className="c-heading c-heading--huge u-mb">{children}</div>
);

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/SectionTitle.jsx